import { StockTransferStatus } from 'store/api/stock-transfers/types';

/**
 * The most a line that is already on a transfer may hold in the edit form
 * (owner 2026-10-15: editing the date, carrier or LTL fields of a transfer
 * must never be blocked by its products).
 *
 * The form used the source storage's count NOW as the limit. On a Completed
 * transfer that stock has already left the source, so an unchanged line was
 * over the limit ("Total count exceeds maximum limit") and the form would not
 * save. The limit now matches what Main checks on save
 * (StockTransferService.updateStockTransfer):
 * - Completed: only an increase leaves the source, so the line may hold what
 *   it already moved plus what the source has now. Unchanged or lower lines
 *   always pass; an increase is checked against the source as before.
 * - Not completed yet: nothing has moved; completing takes the whole count.
 *   An unchanged or lower line passes; a higher one is checked against the
 *   source's count now, as before.
 * A line whose product is not in the source storage list keeps no limit, as
 * before. Lines added in this edit take the source's count from the product
 * picker, unchanged.
 */
export const getEditItemMaxCount = ({
  status,
  savedCount,
  availableNow,
}: {
  savedCount: number;
  status?: StockTransferStatus;
  availableNow?: number | null;
}): number | undefined => {
  const saved = Number(savedCount) || 0;
  const hasAvailable =
    typeof availableNow === 'number' && Number.isFinite(availableNow);

  if (status === StockTransferStatus.Completed) {
    return saved + (hasAvailable ? availableNow : 0);
  }

  return hasAvailable ? Math.max(availableNow, saved) : undefined;
};
